'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { isEzShipRoute } from '@/helpers/utils/urlHelpers';
import { useAppDispatch } from '@/store';
import {
  setCurrentEzShip,
  setEzShipConfig,
  setEzShipTitle,
  setGetEzShipCartItemsStatus,
  setRemoveEzShipCartItemStatus,
} from '@/store/slices/ezship';

const UnloadEzShipInfo = () => {
  const pathname = usePathname();
  const isInEzShipFlow = isEzShipRoute(pathname);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isInEzShipFlow) {
      dispatch(setEzShipConfig(undefined));
      dispatch(setCurrentEzShip(undefined));
      dispatch(setEzShipTitle(undefined));
      dispatch(setGetEzShipCartItemsStatus(undefined));
      dispatch(setRemoveEzShipCartItemStatus(undefined));
    }
  }, [dispatch, isInEzShipFlow]);
  return <></>;
};

export default UnloadEzShipInfo;
